// Script pour traduire les textes de l'application Uploadly
document.addEventListener('DOMContentLoaded', function() {
  // Fonction pour traduire les textes Uploadly
  function translateUploadlyTexts() {
    const currentLang = document.documentElement.lang || 'fr';
    
    // Dictionnaire des traductions
    const translations = {
      'fr': {
        'Add your photos': 'Ajouter mes photos',
        'Upload your photos': 'Télécharger mes photos',
        'Choose files': 'Choisir des fichiers',
        'Drop files here': 'Déposez vos fichiers ici'
      },
      'en': {
        'Add your photos': 'Add my photos',
        'Upload your photos': 'Upload my photos',
        'Choose files': 'Choose files',
        'Drop files here': 'Drop files here'
      }
    };
    
    const texts = translations[currentLang] || translations['en'];
    
    // Remplacer les textes
    Object.keys(texts).forEach(originalText => {
      const translatedText = texts[originalText];
      
      // Chercher tous les éléments qui contiennent le texte original
      const elements = document.querySelectorAll('*');
      elements.forEach(element => {
        if (element.childNodes.length === 1 && element.childNodes[0].nodeType === Node.TEXT_NODE) {
          if (element.textContent.trim() === originalText) {
            element.textContent = translatedText;
          }
        }
      });
    });
  }
  
  // Exécuter la traduction immédiatement
  translateUploadlyTexts();
  
  // Ré-exécuter après un délai pour les éléments chargés dynamiquement
  setTimeout(translateUploadlyTexts, 1000);
  setTimeout(translateUploadlyTexts, 2000);
  setTimeout(translateUploadlyTexts, 3000);
}); 